// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__21JiW","checked":"styles_checked__1PSxf","badge":"styles_badge__1OMOY"};